import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@psspl/utils';
const TONE_CLASS = {
    default: 'bg-surface-raised border-line-subtle',
    raised: 'bg-surface-overlay border-line-strong shadow-raised',
    interactive: 'bg-surface-raised border-line-subtle hover:border-brand-500/45 hover:bg-surface-hover',
};
export function Card({ tone = 'default', header, footer, className, children, ...rest }) {
    return (_jsxs("div", { className: cn('flex flex-col rounded-lg border transition-colors duration-200 ease-out-standard', TONE_CLASS[tone], className), ...rest, children: [header === undefined ? null : (_jsx("div", { className: "border-b border-line-subtle px-5 py-4", children: header })), _jsx("div", { className: "flex-1 px-5 py-4", children: children }), footer === undefined ? null : (_jsx("div", { className: "border-t border-line-subtle px-5 py-4", children: footer }))] }));
}
//# sourceMappingURL=card.js.map